import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["header", "deleteBtn", "deleteMessage"]

  connect() {
    this.updateDeleteButtons()
  }

  updateDeleteButtons() {
    if (this.headerTargets.length === 1) {
      const header = this.headerTargets[0]
      const deleteBtn = this.deleteBtnTargets.find((btn) => header.contains(btn))
      const deleteMessage = this.deleteMessageTargets.find((msg) => header.contains(msg))

      deleteBtn?.classList?.add("d-none")
      deleteMessage?.classList?.remove("d-none")
    } else {
      this.headerTargets.forEach((header) => {
        const deleteBtn = this.deleteBtnTargets.find((btn) => header.contains(btn))
        const deleteMessage = this.deleteMessageTargets.find((msg) => header.contains(msg))

        deleteBtn?.classList?.remove("d-none")
        deleteMessage?.classList?.add("d-none")
      })
    }
  }
}
